export class AlloyManager {
    static getInstance() {
        if (this.instance) {
            return this.instance;
        }
        if (typeof globalThis !== 'undefined' &&
            typeof globalThis.window?.alloy === 'function') {
            this.instance = globalThis.window.alloy;
            return this.instance;
        }
        return null;
    }
}
AlloyManager.instance = null;
